import type {ReactNode} from "react";

export function Bold({children, className}: {children: ReactNode; className?: string}) {
 return (
    <span style={{color: '#51fc1a'}} className={className ?? ''}>{children}</span>
 )
}